import React from "react";
import { EaseModal } from "../../../libs/EaseModal";
import { Text1 } from '../../../styles';
import { SplitForm } from "../../Common/Forms/SplitAccount";

const CreateSplitAccountModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {`${props.selectedSplitAccount ? "Update" : "Create"} Split Account`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={props.onCancel}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <SplitForm
                splitAccount={props.selectedSplitAccount}
                onSubmit={props.saveAccount}
                loading={props.loading}
            />
        </EaseModal>
    )
};

// ContactModal.defaultProps = {
//     contact: {}
// };

export { CreateSplitAccountModal };